import React, { cloneElement, useState } from "react";

import clsx from "clsx";

import { PrimaryButton, SecondaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

interface ConfirmActionButtonV2Props {
  title: string | JSX.Element;
  description?: string | JSX.Element;
  onConfirm: () => void;
  actionButton: JSX.Element;
  onCancel?: () => void;
  dataTestId?: string;
  skipConfirmation?: boolean;
}

export const ConfirmActionButtonV2 = ({
  title,
  description,
  onConfirm,
  actionButton,
  onCancel,
  dataTestId,
  skipConfirmation = false,
}: ConfirmActionButtonV2Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const confirmButton = cloneElement(actionButton, {
    onClick: skipConfirmation ? onConfirm : () => setIsOpen(true),
  });

  const isTitleAnElement = React.isValidElement(title);
  const isDescriptionAnElement = React.isValidElement(description);

  const titleAsJSXElement = isTitleAnElement ? (
    title
  ) : (
    <div className="flex items-start justify-between">
      <h2 className={clsx("font-semibold text-xl", { "mb-2": !!description })}>
        {title}
      </h2>
    </div>
  );

  const descriptionAsJSXElement = isDescriptionAnElement ? (
    description
  ) : (
    <p className="text-sm mb-4 text-subtitle">{description}</p>
  );

  if (skipConfirmation) {
    return confirmButton;
  }

  return (
    <>
      {confirmButton}
      <Modal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
          onCancel?.();
        }}
        hideCloseButton
        titleContent={titleAsJSXElement}
      >
        {description && descriptionAsJSXElement}
        <div className="flex space-x-3 py-4" data-testid={dataTestId}>
          <PrimaryButton
            onClick={() => {
              onConfirm();
              setIsOpen(false);
            }}
          >
            Confirm
          </PrimaryButton>
          <SecondaryButton
            onClick={() => {
              setIsOpen(false);
              onCancel?.();
            }}
          >
            Cancel
          </SecondaryButton>
        </div>
      </Modal>
    </>
  );
};
